module.exports = __webpack_public_path__ + "media/images/sad-face-25072cc93cb67e3da439086a9e60ed9f.png";